import { validateResponse } from '../../../shared/utils/responseHelper';
import apiClient from '../../../shared/services/apiHelper';

export const taskDetailsService = {
  // Fetch maintenance requests list
  fetchMaintenanceRequests: async (currentPage, itemsPerPage, sortField, sortOrder) => {
    try {
      const requestBody = {
        wo_id: '',
        scheduled_date: { from: null, to: null },
        date_range: { from: null, to: null },
        work_status: [],
        service_category: [],
        priority: [],
        client: [],
        date_type: '',
        technician_list: [],
        is_parent: true
      };
      
      const queryParams = { 
        page_number: currentPage,
        limit: itemsPerPage
      };
      
      if (sortField) {
        queryParams.sort = sortField;
        queryParams.order = sortOrder;
      }
      
      const response = await apiClient.post('/task/search', requestBody, queryParams);
      const data = validateResponse(response, 'Failed to fetch maintenance requests');
      
      if (data.success) {
        return {
          maintenanceRequests: data.data || [],
          totalItems: data.total_count || data.total || 0
        };
      } else {
        throw new Error('Failed to fetch maintenance requests');
      }
    } catch (error) {
      console.error('Error fetching maintenance requests:', error);
      throw error;
    }
  },

  // Fetch maintenance details
  getMaintenanceRequestDetails: async (id,expand) => {
    try {
      let url = `/task/${id}`;
      if (expand) {
        url += `?expand=${expand}`;
      }
      const response = await apiClient.get(`${url}`);
      return validateResponse(response, 'Failed to create maintenance request');
    } catch (error) {
      console.error('Error creating maintenance request:', error);
      throw error;
    }
  },

  // Fetch feedback tags
  fetchFeedbackTags: async (clientId, taskId) => {
    try {
      const response = await fetch('http://127.0.0.1:3658/m1/805700-784501-default/task/feedback/tags', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          client_id: clientId,
          task_id: taskId
        })
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error fetching feedback tags:', error);
      throw error;
    }
  },

  // Submit feedback
  submitFeedback: async (requestBody) => {
    try {
      const response = await apiClient.post('/feedback', requestBody);
      return validateResponse(response, 'Failed to submit feedback');
    } catch (error) {
      console.error('Error submitting feedback:', error);
      throw error;
    }
  },

  getFeedbackDetails: async (taskId) => {
    try {
      const response = await apiClient.get(`/feedback?task_id=${taskId}`);
      return validateResponse(response, 'Failed to submit feedback');
    } catch (error) {
      console.error('Error submitting feedback:', error);
      throw error;
    }
  },

  // Generate work report
  generateWorkReport: async (taskId, itemId) => {
    try {
      const response = await apiClient.post('/report/work-report', {
        task_id: taskId,
        item_id: itemId
      });
      const data = validateResponse(response, 'Failed to generate work report');
      
      if (data.success) {
        return data.data?.JobReportUrl || null;
      }
      return null;
    } catch (error) {
      console.error('Error generating work report:', error);
      throw error;
    }
  },

  // Generate invoice
  generateInvoice: async (taskId) => {
    try {
      const response = await apiClient.post('/report/invoice', {
        task_id: taskId
      });
      const data = validateResponse(response, 'Failed to generate invoice');
      
      if (data.success) {
        return data.data?.invoiceUrl || '000';
      }
      return '000';
    } catch (error) {
      console.error('Error generating invoice:', error);
      return '000';
    }
  }
};